"use client";

import { AppErrorFallback } from "@/components/app-error-fallback";

export default function Error({
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  return <AppErrorFallback retry={unstable_retry} />;
}
